import { createFeature, createReducer, on } from '@ngrx/store';

import { UserPreferencesState } from './user-preferences.state';
import { userPreferencesActions } from './user-preferences.actions';

const initialState: UserPreferencesState = {
  sideNavExpanded: false,
};

export const userPreferencesFeature = createFeature({
  name: 'userPreferences',
  reducer: createReducer(
    initialState,
    on(userPreferencesActions.toggleSideNav, (state) => ({
      ...state,
      sideNavExpanded: !state.sideNavExpanded,
    })),
  ),
});
